import React from 'react'
import './print.css'

export default ({children}) => (
    <div className='only-print'>
        {children}
    </div>
)